import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import PropTypes from "prop-types";
import React from 'react';
import FileDrop from "./FormInputs/FileDrop";

FormFileDrop.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
};

export default function FormFileDrop({ fieldName, fieldAttributes }) {

  const { control, getValues } = useFormContext();

  const fieldArrayMethods = useFieldArray({
    control,
    name: fieldName,
    keyName: '_id',
  });

  const onFileAdded = (files) => {
    files.forEach((res) => {
      fieldArrayMethods.append(res[0]);
    })
  }

  const onFileRemoved = (file) => {
    const fileToRemove = getValues(fieldName).findIndex((f) => f.id === file.id);
    fieldArrayMethods.update(fileToRemove, file);
  }

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => {
        const files = field.value?.filter((f) => !f.deleteFlag) ?? [];

        return (
          <FileDrop
            fieldAttributes={fieldAttributes}
            onFileRemoved={onFileRemoved}
            onFileAdded={onFileAdded}
            files={files}
          />
        );
      }}
    />
  );
}